import { selectors } from '@arfabrands/gatsby-theme-assembly'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const useProductDetails = ({ slug, sku }) => {
  const { getAllProducts } = selectors
  const products = useSelector(getAllProducts)

  const [image, setImage] = useState(null)
  const [parts, setParts] = useState(null)

  useEffect(() => {
    const product = products.find(p => p.slug === slug)

    if (!product) return

    const isKit = sku.includes('|')

    const image = isKit
      ? product.mainImage
      : product.variants.find(v => v.sku === sku).mainImage

    if (isKit) {
      const skus = sku.split('|')

      setParts(
        product.products.map(p => p.variants.find(v => skus.includes(v.sku)))
      )
    }

    if (image) setImage(image)
  }, [products, sku, slug])

  return { image, parts }
}

export default useProductDetails
